export function addIndexName(hit, indexName) {
  return {
    ...hit,
    __indexName: indexName
  };
}